import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchMainICafe } from "@features/account/api/fetchMainICafeApi";
import { loginQueryKeys } from "@features/auth/hooks/queries/keys/loginQueryKeys";
import { QUERY_KEYS as CONTACT_QUERY_KEYS } from "@features/helpdesk/hooks/queries/useArticles";
import { QUERY_KEYS as NONPAID_REPORT_QUERY_KEYS } from "@features/helpdesk/hooks/queries/useNonpaidReports";

// 대표 PC방 변경
export const useUpdateMainICafe = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (iCafeId: string) => fetchMainICafe(iCafeId),
    onSuccess: async (data, variables) => {
      await Promise.all([
        // 사업장 목록 캐시 무효화
        queryClient.invalidateQueries({
          queryKey: ["iCafeList"],
        }),

        // 대표 PC방 정보 캐시 무효화
        queryClient.invalidateQueries({
          ...loginQueryKeys.loginICafeInfo.info(variables),
        }),

        // 고객센터 - 1:1 문의 리스트 데이터 캐시 무효화
        queryClient.invalidateQueries({
          queryKey: [CONTACT_QUERY_KEYS.GET_ARTICLES],
        }),

        // 고객센터 - 미납자신고 리스트 데이터 캐시 무효화
        queryClient.invalidateQueries({
          queryKey: [NONPAID_REPORT_QUERY_KEYS.GET_NONPAID_REPORTS],
        }),

        // IP 실시간 관리
        queryClient.invalidateQueries({
          queryKey: ["ipList"],
        }),
      ]);
    },
  });
};
